import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { TranscribeStreamingClient } from "@aws-sdk/client-transcribe-streaming";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

import { viteEnv } from "utils/vite-env.util";

const REGION = "us-east-1";
const IDENTITY_POOL_ID = viteEnv.VITE_TRANSCRIBE_IDENTITY_POOL_ID || "";

/**
 * Build a TranscribeStreamingClient.
 *
 * Callers that destroy() the client when a stream ends MUST own their own
 * instance — destroying a shared module-level client leaves every later
 * caller with a dead client for the rest of the page session.
 */
const createTranscribeClient = (): TranscribeStreamingClient =>
  new TranscribeStreamingClient({
    region: REGION,
    credentials: fromCognitoIdentityPool({
      client: new CognitoIdentityClient({ region: REGION }),
      identityPoolId: IDENTITY_POOL_ID
    })
  });

export { createTranscribeClient };
